import { render, staticRenderFns } from "./sysSet.vue?vue&type=template&id=2b57ae1c&scoped=true&"
import script from "./sysSet.vue?vue&type=script&lang=js&"
export * from "./sysSet.vue?vue&type=script&lang=js&"
import style0 from "./sysSet.vue?vue&type=style&index=0&id=2b57ae1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57ae1c",
  null
  
)

export default component.exports